import { Box, Image } from "@chakra-ui/react";
import { LeftHandleIcon, RightHandleIcon } from "@root/assets/icons";
import { ImageSliderModal } from "@root/components/image-slider-modal";
import { useState } from "react";
import { AdditionalInfo } from "../additionalInfo";
import SystemChat from "./system/systemChat";
import UserChat from "./user/userChat";

import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import ChatSources from "../sources/ChatSources";
import SearchSources from "../sources/SearchSources";

function ChatBody(props: any) {
  const { chat, uid, editSubmitHandler, mode, loading } = props;
  const [editable, setEditable] = useState(false);
  const [imageSliderPopup, setImageSliderPopup] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [sliderImages, setSliderImages] = useState([]);

  const onEdit = (input: string) => {
    editSubmitHandler({
      input,
      chat,
    });
  };
  const searchSources =
    chat?.meta?.search_sources || chat?.meta?.c?.search_sources;
  const parsedSources = searchSources ? JSON.parse(searchSources) : [];
  // unqiue sources by title
  const uniqueSources = parsedSources.filter(
    (source: any, index: number) =>
      parsedSources.findIndex((s: any) => s.title === source.title) === index
  );
  const parsedChatSources = chat?.meta?.sources || chat?.meta?.c?.sources || [];
  // unqiue sources by filename
  const uniqueChatSources = parsedChatSources.filter(
    (source: any, index: number) =>
      parsedChatSources.findIndex(
        (s: any) => s.filename === source.filename
      ) === index
  );

  const CustomLeftArrow = ({ onClick }: any) => (
    <Box
      as={LeftHandleIcon}
      aria-label="Previous"
      onClick={onClick}
      position="absolute"
      left="-25px"
      top="50%"
      zIndex="2"
      fontSize="30px"
      transform="translateY(-50%)"
      _hover={{ color: "black.500" }}
    />
  );

  const CustomRightArrow = ({ onClick }: any) => (
    <Box
      as={RightHandleIcon}
      aria-label="Next"
      onClick={onClick}
      position="absolute"
      right="-25px"
      top="50%"
      zIndex="2"
      fontSize="30px"
      transform="translateY(-50%)"
      _hover={{ color: "black.100" }}
    />
  );

  const sliderSettings = {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: chat?.meta?.signed_files?.length === 1 ? 1 : 3,
    slidesToScroll: 1,
    centerMode: chat?.meta?.signed_files?.length === 1,
    centerPadding: chat?.meta?.signed_files?.length === 1 ? "0" : "20px",
    nextArrow: <CustomRightArrow />,
    prevArrow: <CustomLeftArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: chat?.meta?.signed_files?.length === 1 ? 1 : 3,
          slidesToScroll: 1,
          centerMode: chat?.meta?.signed_files?.length === 1,
          centerPadding: chat?.meta?.signed_files?.length === 1 ? "0" : "20px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: chat?.meta?.signed_files?.length === 1 ? 1 : 2,
          slidesToScroll: 1,
          centerMode: chat?.meta?.signed_files?.length === 1,
          centerPadding: chat?.meta?.signed_files?.length === 1 ? "0" : "20px",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: chat?.meta?.signed_files?.length === 1 ? 1 : 1,
          slidesToScroll: 1,
          centerMode: chat?.meta?.signed_files?.length === 1,
          centerPadding: chat?.meta?.signed_files?.length === 1 ? "0" : "20px",
        },
      },
    ],
  };

  const signedFilesLength = chat?.meta?.signed_files?.length;

  return (
    <Box flex={1}>
      {chat?.role === "user" && (
        <UserChat
          editable={editable}
          setEditable={setEditable}
          editSubmitHandler={onEdit}
          uid={uid}
          chat={chat}
          mode={mode}
          loading={loading}
        />
      )}
      {chat?.role === "assistent" && (
        <Box>
          <Box
            bgColor={chat?.error ? "transparent" : "transparent"}
            border={chat?.error ? "1px solid" : "none"}
            borderColor={chat?.error ? "transparent" : "transparent"}
            borderRadius={"16px"}
            width={"97%"}
            my={"15px"}
          >
            <SystemChat
              mode={mode}
              editSubmitHandler={onEdit}
              uid={uid}
              chat={chat}
            />
            {/* Images Carousel */}
            <Box
              width="100%"
              margin="10px auto 60px auto"
              padding="0 50px"
              overflow="hidden"
            >
              {signedFilesLength > 0 && signedFilesLength < 3 ? (
                <Box display="flex">
                  {chat?.meta?.signed_files.map(
                    (url: string, index: number) => (
                      <Box
                        display={"flex"}
                        key={index}
                        padding="5px"
                        margin="0"
                      >
                        <Image
                          src={url}
                          alt={`Image ${index + 1}`}
                          width={"210px"}
                          height="110px"
                          borderRadius="12px"
                          objectFit="cover"
                          border="2px solid"
                          borderColor="gray.300"
                          cursor="pointer"
                          onClick={() => {
                            setImageSliderPopup(true);
                            setSliderImages(chat.meta.signed_files);
                            setSelectedIndex(index);
                          }}
                        />
                      </Box>
                    )
                  )}
                </Box>
              ) : (
                signedFilesLength > 0 && (
                  <Slider {...sliderSettings}>
                    {chat?.meta?.signed_files.map(
                      (url: string, index: number) => (
                        <Box
                          display={"flex"}
                          key={index}
                          padding="5px"
                          margin="0"
                        >
                          <Image
                            src={url}
                            alt={`Image ${index + 1}`}
                            width={"210px"}
                            height="110px"
                            borderRadius="12px"
                            objectFit="cover"
                            border="2px solid"
                            borderColor="gray.300"
                            cursor="pointer"
                            onClick={() => {
                              setImageSliderPopup(true);
                              setSliderImages(chat.meta.signed_files);
                              setSelectedIndex(index);
                            }}
                          />
                        </Box>
                      )
                    )}
                  </Slider>
                )
              )}
            </Box>

            {/* Share & Copy buttons */}
            <Box>
              {!chat?.error && <AdditionalInfo chat={chat} uid={uid} />}
            </Box>
          </Box>
          <Box mb={"30px"} mt={4} maxW={"97%"}>
            {mode === "search" ? (
              <>
                {uniqueSources?.length > 0 ? (
                  <SearchSources sources={uniqueSources} />
                ) : null}
              </>
            ) : mode === "chat" ? (
              <>
                {/* {" "}
                {uniqueChatSources?.length > 0 ? (
                  <ChatSources sources={uniqueChatSources} />
                ) : null} */}
              </>
            ) : null}
          </Box>
        </Box>
      )}

      {/* Modal and Zoom features */}
      <ImageSliderModal
        isOpen={imageSliderPopup}
        onClose={() => {
          setImageSliderPopup(false);
          setSelectedIndex(0);
        }}
        selectedIndex={selectedIndex}
        data={sliderImages}
      />
    </Box>
  );
}

export default ChatBody;
